import { AssetGroupType, AuroraModel } from '../enums'
import { AssetType } from '../enums/AssetType'
import {
  Aurora,
  AuroraAsset,
  AuroraAssetGroup,
  AuroraAwhpActionEvent,
  AuroraAwhpAlarmEvent,
  AuroraAwhpData,
  Sensor
} from '../types'
import { calculatePower } from './sensor'

export function isAuroraAssetGroup(value: unknown): value is AuroraAssetGroup {
  if (value === null || typeof value !== 'object' || 'type' in value === false) {
    return false
  }

  return value.type === AssetGroupType.AURORA
}

export function isAuroraAsset(value: unknown): value is AuroraAsset {
  if (value === null || typeof value !== 'object' || 'type' in value === false) {
    return false
  }

  return value.type === AssetType.AURORA
}

export function isAuroraAwhpActionEvent(value: unknown): value is AuroraAwhpActionEvent {
  if (value === null || typeof value !== 'object' || 'key' in value === false) {
    return false
  }

  return value.key === 'DEFROST' || value.key === 'HOLIDAY_MODE' || value.key === 'PUMP_ON'
}

export function isAuroraAwhpAlarmEvent(value: unknown): value is AuroraAwhpAlarmEvent {
  if (value === null || typeof value !== 'object' || 'key' in value === false) {
    return false
  }

  return (
    value.key === 'PUMP_ALARM' ||
    value.key === 'LOW_FLOW_ALARM' ||
    value.key === 'LOW_PRESSURE_ALARM' ||
    value.key === 'LOW_SEC_SUPPLY_TEMP_ALARM' ||
    value.key === 'VILP_FAULT_ALARM'
  )
}

export function calculateAuroraHeatOutput(aurora: Aurora, auroraAwhpData: AuroraAwhpData) {
  if (auroraAwhpData?.heating_power != null) {
    return (auroraAwhpData.heat_pump_frequency / 180) * auroraAwhpData.heating_power
  }

  return aurora?.heatingPower !== null
    ? (auroraAwhpData.heat_pump_frequency / 180) * aurora.heatingPower
    : null
}

export function calculateAuroraHeatOutputPercentage(
  aurora: Aurora,
  auroraAwhpData: AuroraAwhpData
) {
  return (auroraAwhpData.heat_pump_frequency / 180) * 100
}

export function formatAuroraId(aurora: Aurora | string) {
  if (typeof aurora === 'string') {
    return /^\d{6}$/.test(aurora) ? aurora : aurora.slice(-6).toUpperCase()
  }

  return /^\d{6}$/.test(aurora.id) ? aurora.id : aurora.id.slice(-6).toUpperCase()
}

export function checkIsAuroraBackup(aurora: Aurora) {
  const regex = new RegExp(`^${AuroraModel.AURORA_64}`, 'i')
  return regex.test(aurora?.catalogProduct?.name ?? '')
}

export function checkIsAuroraAwhp(aurora: Aurora) {
  return !checkIsAuroraBackup(aurora)
}
